import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import SessionManager from "@/apollo/datasources/sessionManager";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import Cookies from "@/lib/cookies";
import dayjs from "@/lib/day";
import { AuthenticationError } from "apollo-server-errors";
import { createHash } from "crypto";
import jwt from "jsonwebtoken";
export default class IdcToken {
  constructor(req, res) {
    var _config$idcToken$redi, _config$idcToken$redi2, _config$idcToken$redi3, _config$idcToken;
    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$idcToken$redi = config.idcToken.redis) === null || _config$idcToken$redi === void 0 ? void 0 : _config$idcToken$redi.host),
      port: process.env.REDIS_PORT || ((_config$idcToken$redi2 = config.idcToken.redis) === null || _config$idcToken$redi2 === void 0 ? void 0 : _config$idcToken$redi2.port),
      keyPrefix: config.idcToken.redis.prefix,
      db: (_config$idcToken$redi3 = config.idcToken.redis) === null || _config$idcToken$redi3 === void 0 ? void 0 : _config$idcToken$redi3.db
    }, (_config$idcToken = config.idcToken) === null || _config$idcToken === void 0 || (_config$idcToken = _config$idcToken.redis) === null || _config$idcToken === void 0 ? void 0 : _config$idcToken.cluster);
  }
  get cookieName() {
    return config.idcToken.name;
  }
  getToken() {
    return this.cookies.get(this.cookieName);
  }
  get signatureName() {
    return config.idcToken.signature;
  }
  getSignature() {
    return this.cookies.get(this.signatureName);
  }
  getSecret() {
    let signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (!signature) {
      signature = this.getSignature();
    }
    return `${signature}${config.idcToken.secret}`;
  }
  generateKey(id, signature) {
    const key = (() => {
      return `idcToken:${id}:${signature}`;
    })();
    return createHash("sha256").update(key).digest("hex");
  }
  async setPayload(payload, signature) {
    const key = this.generateKey(payload.id, signature);
    await this.redis.multi().set(key, JSON.stringify(payload)).expire(key, config.idcToken.maxAge).exec();
    return key;
  }
  async getPayload(key) {
    const json = await this.redis.get(key);
    return JSON.parse(json);
  }
  deletePayload(key) {
    return this.redis.del(key);
  }
  async sign(payload, signature) {
    if (!signature) {
      signature = this.getSignature();
    }
    const key = await this.setPayload(payload, signature);
    const secret = this.getSecret(signature);
    const token = jwt.sign({
      key
    }, secret);
    const options = {
      maxAge: config.idcToken.maxAge
    };
    this.cookies.set([{
      name: this.signatureName,
      value: signature,
      options
    }, {
      name: this.cookieName,
      value: token,
      options
    }]);
    return token;
  }
  async verify() {
    // cookieからtokenを取得
    const token = this.getToken();
    if (!token) return false;
    // cookieからsignatureを取得
    const secret = this.getSecret();
    // tokenを検証
    const verifiedToken = jwt.verify(token, secret);
    // redisからpayloadを取得
    const payload = await this.getPayload(verifiedToken.key);
    if (!payload) return false;
    return _objectSpread(_objectSpread({}, verifiedToken), {}, {
      payload
    });
  }
  async delete() {
    const token = this.getToken();
    if (!token) {
      console.log("userToken delete, token not found");
      return false;
    }
    try {
      const secret = this.getSecret();
      const verifiedToken = jwt.verify(token, secret);
      await this.deletePayload(verifiedToken.key);
    } catch (e) {
      console.log("token delete error", e);
    } finally {
      this.cookies.remove([this.cookieName, this.signatureName, [config.optionalTermsConfirmCookieName, {
        domain: null
      }]]);
    }
  }
  async deleteAll() {
    const removeCookies = [[config.optionalTermsConfirmCookieName, {
      domain: null
    }]];
    try {
      [true, false].forEach(async val => {
        const token = this.getToken();
        if (token) {
          const secret = this.getSecret();
          const verifiedToken = jwt.verify(token, secret);
          removeCookies.push(this.cookieName);
          removeCookies.push(this.signatureName);
          await this.deletePayload(verifiedToken.key);
        }
      });
    } catch (e) {
      console.log("token delete error", e);
    } finally {
      this.cookies.remove(removeCookies);
    }
  }
}